<template>
    <TasksListComponent :title="$t('taskViews.transmitterRelated')" :apiUrl="apiUrl" />
</template>

<script>
import TasksListComponent from '@/components/TasksListComponent.vue';

export default {
    name: 'TasksTransmitterRelatedListView',
    components: {
        TasksListComponent
    },
    computed: {
        apiUrl() {
            const baseApiUrl = 'tasks/';
            const params = new URLSearchParams({
                finished: '0',
                is_transmitter_related: '1',
                users: this.currentUser.id,
                sort_by: 'due_date',
                sort_order: 'asc'
            });
            return `${baseApiUrl}?${params.toString()}`;
        },
        currentUser() {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        }
    }
};
</script>
